import { BoardViewDetail } from '../board/BoardViewDetail';
import { useAuthContext } from '../../contexts/AuthContext';
import { useSearchParams } from 'react-router-dom';
import { useZoneContext } from '../../contexts/useZoneContext';

function BoardCaseViewWrapper() {
    const [searchParams] = useSearchParams();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    const type: string = searchParams.get('preferences') || '';
    const preferences: string = searchParams.get('preferences') || '';

    return (
        <BoardViewDetail
            user={user}
            type={type}
            preferences={preferences}
            zoneContext={zoneContext}
        />
    );
}

export default BoardCaseViewWrapper;
